import { List } from 'react-admin';
import { Box } from '@mui/material';
import { ReorderableDatagrid, imageCell } from '../../components/ReorderableDatagrid.jsx';

export const SlideList = () => (
  <List
    sort={{ field: 'sortOrder', order: 'ASC' }}
    perPage={100}
    pagination={false}
    empty={false}
  >
    <ReorderableDatagrid
      columns={[
        { key: 'image', header: 'Image', width: 100, render: (r) => imageCell(r.image) },
        { key: 'headline', header: 'Headline', render: (r) => (
          <Box dangerouslySetInnerHTML={{ __html: r.headline || '' }} sx={{ '& em': { color: 'secondary.main' } }} />
        ) },
        { key: 'eyebrow', header: 'Eyebrow', render: (r) => r.eyebrow || '—' },
        { key: 'isActive', header: 'Active', width: 80, render: (r) => r.isActive ? '✓' : '—' },
      ]}
    />
  </List>
);
